var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-chart',{staticClass:"w-100 h-100",attrs:{"options":_vm.options}})
}
var staticRenderFns = []

export { render, staticRenderFns }